<template>
  <PossiblePMS
    v-if="isEndServiceEligible"
    v-slot="{ disabled }"
    :sync-obj="syncObj"
    check-enrollment-mode
    inline
    :content-class="contentClass"
  >
    <DialogRemoveDevices
      :unit="unit"
      :renter-synced="disabled"
      :ended-service="endedService"
      v-on="$listeners"
    />
  </PossiblePMS>
</template>

<script>
import PossiblePMS from "./PossiblePMS.vue";
import DialogRemoveDevices from "../renters/DialogRemoveDevices.vue";
import usePMS from "./usePMS";

export default {
  name: "ButtonEndService",
  components: { PossiblePMS, DialogRemoveDevices },
  props: {
    unit: {
      type: Object,
      required: true,
    },
    endedService: {
      type: Boolean,
      default: false,
    },
    syncObj: {
      type: Object,
      required: true,
    },
    contentClass: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { isEndServiceEligible } = usePMS();
    return { isEndServiceEligible };
  },
};
</script>
